export default __webpack_public_path__ + "static/media/header.c47d8fe5.jpg";